import { trans } from "@/service/i18n/i18n";
import { ProfileImage } from "@/components/common/profile-image";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ImageIcon } from "lucide-react";
import { useRef } from "react";

export function ThemeAvatar({
  field,
  formField,
  onInput,
  imageOnClick = () => {},
}: {
  field: Field;
  formField: any;
  onInput: any;
  imageOnClick: any;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  const triggerFileInput = () => {
    inputRef.current?.click();
  };

  return (
    <div>
      <label htmlFor={field.name}>
        {field.label && (
          <Label className={"mb-2"} htmlFor={field.name}>
            {trans(field.label)}
          </Label>
        )}
        <div className={"flex items-center gap-6"}>
          {field.value ? (
            <img
              className={"h-15 w-15 rounded-full object-cover"}
              src={field.value}
              alt={"avatar"}
            />
          ) : (
            <ProfileImage size={"large"} />
          )}
          <Button
            type={"button"}
            onClick={triggerFileInput}
            variant={"outline"}
          >
            <ImageIcon size={16} />{" "}
            {!field.value ? "Dodaj zdjęcie" : "Zmień zdjęcie"}
          </Button>
        </div>

        <input
          type="file"
          name={field.name}
          id={field.name}
          accept="image/*"
          onInput={(event) => {
            onInput(event);
          }}
          ref={(el) => {
            formField.ref(el);
            inputRef.current = el;
          }}
          className={"hidden"}
        />
      </label>
    </div>
  );
}
